var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h2", { staticClass: "page-title" }, [_vm._v("幼猫（可预订）排序：")]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: "请拖拽猫卡片排序（顺序从左到右，从上到下）",
                name: "first"
              }
            },
            [
              _c(
                "vuedraggable",
                {
                  on: { end: _vm.end },
                  model: {
                    value: _vm.catList,
                    callback: function($$v) {
                      _vm.catList = $$v
                    },
                    expression: "catList"
                  }
                },
                _vm._l(_vm.catList, function(cat) {
                  return _c(
                    "el-tag",
                    {
                      key: cat.id,
                      staticClass: "draggable-tag",
                      attrs: { "disable-transitions": false }
                    },
                    [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(cat.name))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "banner-img" }, [
                        _c("img", { attrs: { src: cat.cat_img.banner_img } })
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }